import * as apiCaller from "../helpers/apiCaller";
import { getCookie, setCookie } from "../helpers/cookies";
import store from 'src/configure-store';
const requestCultureType = "CHANGE_CULTURE";
const supportedLocales = ["ru", "uk", "en", "he"];
const defaultLocale = "uk";

export function changeCulture(culture) {
  return async dispatch => {

    var state = store.getState();

    if(state.culture.locale === culture) return;

    if(!culture){
      let cultureFromCookie = getCookie(".AspNetCore.Culture");
      if(cultureFromCookie){
        culture = cultureFromCookie.slice(-2);
      }
    }

    // Never let an unset/unknown culture (e.g. a user with no language, or a
    // region-qualified cookie like "en-US") become the locale — it has no entry
    // in the translations and would break translate(). Fall back to the default.
    if(!supportedLocales.includes(culture)){
      culture = defaultLocale;
    }

    apiCaller.post(`/home/setLanguageFront?culture=${culture}`, {}, true);

    setCookie(".AspNetCore.Culture", culture, 180);

    dispatch({ type: requestCultureType, culture });
    
    if(culture === "he"){
      document.dir = 'rtl';
    }else{
      document.dir = 'ltr';
    }
  };
}

export const actionCreators = {
  changeCulture
};


let cultureCookie = getCookie(".AspNetCore.Culture");

if (cultureCookie) {
  cultureCookie = cultureCookie.slice(-2);
  if(cultureCookie === "he"){
    document.dir = 'rtl';
  }
}

if (!supportedLocales.includes(cultureCookie)) {
  cultureCookie = defaultLocale;
}

const defaultState = {
  locale: cultureCookie,
  dir: cultureCookie === "he" ? "rtl" : "ltr"
}

export const culture = (state = defaultState , action) => {
  if (action.type === requestCultureType) {
    return {
      locale: action.culture,
      dir: action.culture === "he" ? "rtl" : "ltr" 
    };
  }

  return state;
};
